import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { MdmCommandProgressService } from '@rocksoft/mdm-sdk-v2';
import { mergeMap } from 'rxjs/operators';
import { safeMap } from '../effects.helpers';
import { CommandProgressApiActions, CommandProgressResolverActions } from './command-progress.actions';

@Injectable()
export class CommandProgressEffects {
  private readonly actions$ = inject(Actions);
  private readonly api = inject(MdmCommandProgressService);

  loadCommandProgressEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CommandProgressResolverActions.commandProgressRequested),
      mergeMap(({ udid, page }) =>
        safeMap(
          this.api.getCommandProgresses({ udid, apiVersion: '2.0', page }),
          (commandProgresses) => CommandProgressApiActions.commandProgressLoaded({ commandProgresses }),
          (error) => CommandProgressApiActions.commandProgressLoadedError({ error })
        )
      )
    );
  });
}
